import {FrontWebDetailPodcastEpisodeModel, FrontWebPodcastEpisodeModel, FrontWebPodcastProgramModel} from "../../../../../../../../generated";
import H2Header from "../../../../components/H2Header";
import {EpisodeRow} from "../../../../../../../../components/Item/Podcast/EpisodeRow";

export default function MainEpisode(props: {
    episode: FrontWebDetailPodcastEpisodeModel,
    episodeId: number,
    program: FrontWebPodcastProgramModel,
}) {

    return <>
        <H2Header>{props.episode.name}</H2Header>
        <EpisodeRow asMain={true} episode={props.episode as FrontWebPodcastEpisodeModel} asHref={false}/>
    </>
}